/**
 * 多语言文件映射
 * @author zhengchao
 * @Date 2017-05-19
 * hk:用来表示 是否需要 繁文 字体
 * 具体用法 请参照okex  index
 */
import Cookies from 'js-cookie';
import { toLocale, toLocaleWithJSX } from '@ok/blade';

import { SUPPORT } from './LinkType';

if (
  process.env.NODE_ENV === 'development' &&
  Cookies.get('locale') === undefined
) {
  Cookies.set('locale', 'zh_CN');
  // eslint-disable-next-line @ok/oklint/no-location-reload
  window.location.reload();
}

const language =
  Cookies.get('locale') ||
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;
const langType = language.toLowerCase();

let isDEV = false;
if (process.env.ASSETS_BUILD_TYPE) {
  isDEV = process.env.ASSETS_BUILD_TYPE === 'daily';
} else {
  isDEV = process.env.NODE_ENV !== 'production';
}

const localeData = {};

/**
 * 取本地多语言数据
 * @param id
 * @param value
 * @returns {*}
 */
function getLocaleData(id, value) {
  if (!value) {
    return localeData[id];
  }
  let str = localeData[id];
  Object.entries(value).forEach((item) => {
    const reg = new RegExp(`{${item[0]}}`, 'g');
    str = str.replace(reg, item[1]);
  });

  return str;
}

/**
 * 国际化
 * @template {boolean} [T=false]
 * @param {string} id
 * @param {Record<string, any>} [values]
 * @param {T} [withJSX]
 * @returns {T extends true ? React.ReactNode : string}
 */
export function translate(id, values, withJSX = false) {
  if (window.showKey) {
    return id;
  }
  let str = '';
  // 线上用多语言系统，其他环境本地有本地数据用本地数据
  if (!isDEV || !localeData[id]) {
    if (withJSX) {
      str = toLocaleWithJSX(id, values) || '';
    } else {
      str = toLocale(id, values) || '';
    }
  } else {
    str = getLocaleData(id, values);
  }
  return str;
}

export function getSupportLink(linkType) {
  const zhCn = 'zh_cn';
  const enUs = 'en_us';

  switch (linkType) {
    case SUPPORT.INSIDER:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000242673689';
        case enUs:
          return 'https://support.okj.com/hc/en-us/articles/59000242673689';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000242673689';
      }
    case SUPPORT.PEPS:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000216286233';
        case enUs:
          return 'https://support.okj.com/hc/en-us/articles/59000216286233';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000216286233';
      }
    case SUPPORT.US_PAYER:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000244402329';
        case enUs:
          return 'https://support.okj.com/hc/en-us/articles/59000244402329';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000244402329';
      }
    case SUPPORT.AML_CFT:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000229955353';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000229955353';
      }
    case SUPPORT.ANTISOCIAL:
      return 'https://support.okj.com/hc/ja/articles/59000228078617';
    case SUPPORT.ID_UPLOAD:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000195187353';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000195187353';
      }
    case SUPPORT.GOOGLE_AUTHENTICATOR:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000200832153';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000200832153';
      }
    case SUPPORT.BANK_CARD_UPLOAD:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000150270873';
        case enUs:
          return 'https://support.okj.com/hc/en-us/articles/59000150270873';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000150270873';
      }
    case SUPPORT.WITHDRAW_FEE:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/zh-cn/articles/59000206376345';
        case enUs:
          return 'https://support.okj.com/hc/en-us/articles/59000206376345';
        default:
          return 'https://support.okj.com/hc/ja/articles/59000206376345';
      }
    case SUPPORT.BAN_COUNTRY:
      switch (langType) {
        case zhCn:
          return 'https://support.okj.com/hc/ja/articles/59016832348313';
        case enUs:
          return 'https://support.okj.com/hc/ja/articles/59016832348313';
        default:
          return 'https://support.okj.com/hc/ja/articles/59016832348313';
      }
    default:
      return '';
  }
}
